import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {CircleWarningIcon} from 'shells/icon/svg/circle-warning-icon';
import {TwoLineMiniCard} from 'shells/two-line/two-line-mini-card';

import styles from './activate-form-modal.module.css';

type Props = {
    fieldCount: number;
};

export function UnconnectedFieldsSection(props: Props) {
    const fieldCountText = `${props.fieldCount} field${props.fieldCount === 1 ? '' : 's'}`;
    const fieldCountVerb = props.fieldCount === 1 ? 'is' : 'are';

    return (
        <div className={styles['fields-section']}>
            <div className={styles.description}>
                <strong>{fieldCountText}</strong> {fieldCountVerb} <i>not connected</i> and won’t
                add any data:
            </div>
            <TwoLineMiniCard
                icon={CircleWarningIcon}
                iconColor={colors.orangeAttention}
                iconSize={16}
                topRow='Not connected'
                bottomRow={fieldCountText}
                width={325}
            />
        </div>
    );
}
